import React, { useState,useEffect } from 'react';
import './Coding.css';

import web_development_0 from "../../../asset/web_development_0.svg";
import web_development_1 from "../../../asset/web_development_1.svg";
import web_development_2 from "../../../asset/web_development_2.svg";
import web_development_3 from "../../../asset/web_development_3.svg";
import web_development_4 from "../../../asset/web_development_4.svg";
import web_development_5 from "../../../asset/web_development_5.svg";
import web_development_6 from "../../../asset/web_development_6.svg";
import web_development_7 from "../../../asset/web_development_7.svg";
import web_development_8 from "../../../asset/web_development_8.svg";
import web_development_9 from "../../../asset/web_development_9.svg";
import web_development_10 from "../../../asset/web_development_10.svg";
import web_development_11 from "../../../asset/web_development_11.svg";
import web_development_12 from "../../../asset/web_development_12.svg";
import web_development_13 from "../../../asset/web_development_13.svg";
import web_development_14 from "../../../asset/web_development_14.svg";
import web_development_15 from "../../../asset/web_development_15.svg";

import main_work_1 from "../../../asset/coding_1.svg";
import main_work_2 from "../../../asset/coding_2.svg";
import main_work_3 from "../../../asset/coding_8.png";

import toy_work_1 from "../../../asset/coding_3.svg";
import toy_work_2 from "../../../asset/coding_4.svg";
import toy_work_3 from "../../../asset/coding_5.png";
import toy_work_4 from "../../../asset/coding_6.svg";
import toy_work_5 from "../../../asset/coding_7.png";

import red_dot from "../../../asset/main-projects.svg";
import yellow_dot from "../../../asset/toy-projects.svg";

import selected from "../../../asset/image_selected.svg";

import visit from "../../../asset/visit.svg";

function Coding() {
    const [selectedCell, setSelectedCell] = useState(null);
    const [selectedInfo, setSelectedInfo] = useState(
        <div
            className="select-one"
        >
            select one on the right
        </div>
    );

    const [blueCells, setBlueCells] = useState([]);

    const web_development = [
        web_development_0,
        web_development_1,
        web_development_2,
        web_development_3,
        web_development_4,
        web_development_5,
        web_development_6,
        web_development_7,
        web_development_8,
        web_development_9,
        web_development_10,
        web_development_11,
        web_development_12,
        web_development_13,
        web_development_14,
        web_development_15
    ];

    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) =>
                (prevIndex + 1) % web_development.length // 0에서 15까지 순환
            );
        }, 100); // 100ms 마다 이미지 변경 (0.1초)

        return () => clearInterval(interval); // 컴포넌트가 언마운트될 때 클리어
    }, [web_development.length]);

    useEffect(() => {
        const totalCells = 110;
        const numberOfBlueCells = 20;
        const generatedBlueCells = new Set();

        while (generatedBlueCells.size < numberOfBlueCells) {
            const randomIndex = Math.floor(Math.random() * totalCells);
            generatedBlueCells.add(randomIndex);
        }

        setBlueCells(Array.from(generatedBlueCells));
    }, []);

    const handleClick = (index) => {
        setSelectedCell(index); // 클릭한 셀의 인덱스를 저장

        if (index === 12) {
            setSelectedInfo(
                <div
                    className="selected-info"
                >
                    <img
                        className="selected-info-img"
                        alt={""}
                        src={main_work_1}
                    />
                    <div
                        className="selected-info-msg"
                    >
                        첫번째 포트폴리오 / first portfolio as a web developer <br />
                        - 2020.12
                        < a href="https://intothejourneys.github.io/portfolio/" target="_blank" rel="noopener noreferrer">
                            <img
                                className="visit"
                                src={visit}
                                alt="visit"
                            />
                        </a>
                    </div>
                </div>
            );
        } else if (index === 14) {
            setSelectedInfo(
                <div
                    className="selected-info"
                >
                    <img
                        className="selected-info-img"
                        alt={""}
                        src={main_work_2}
                    />
                    <div
                        className="selected-info-msg"
                    >
                        현재 포트폴리오 / current portfolio web site <br />
                        - 2024.09
                        < a href="https://ineverstay.com" target="_blank" rel="noopener noreferrer">
                            <img
                                className="visit"
                                src={visit}
                                alt="visit"
                            />
                        </a>
                    </div>
                </div>
            );
        } else if (index === 43) {
            setSelectedInfo(
                <div
                    className="selected-info"
                >
                    <img
                        className="selected-info-img"
                        alt={""}
                        src={toy_work_1}
                    />
                    <div
                        className="selected-info-msg"
                    >
                        도시의 하루 / this city <br />
                        - 2024.07
                        < a href="https://thiscity.netlify.app/" target="_blank" rel="noopener noreferrer">
                            <img
                                className="visit"
                                src={visit}
                                alt="visit"
                            />
                        </a>
                    </div>
                </div>
            );
        } else if (index === 45) {
            setSelectedInfo(
                <div
                    className="selected-info"
                >
                    <img
                        className="selected-info-img"
                        alt={""}
                        src={toy_work_2}
                    />
                    <div
                        className="selected-info-msg"
                    >
                        제주도의 어미소와 아기소 / cow project <br />
                        - 2024.08
                        < a href="https://cowproject2024.netlify.app/" target="_blank" rel="noopener noreferrer">
                            <img
                                className="visit"
                                src={visit}
                                alt="visit"
                            />
                        </a>
                    </div>
                </div>
            );
        } else if (index === 74) {
            setSelectedInfo(
                <div
                    className="selected-info"
                >
                    <img
                        className="selected-info-img"
                        alt={""}
                        src={toy_work_3}
                    />
                    <div
                        className="selected-info-msg"
                    >
                        another hundred <br />
                        - 2024.08
                        < a href="https://anotherhundred.netlify.app/" target="_blank" rel="noopener noreferrer">
                            <img
                                className="visit"
                                src={visit}
                                alt="visit"
                            />
                        </a>
                    </div>
                </div>
            );
        } else if (index === 76) {
            setSelectedInfo(
                <div
                    className="selected-info"
                >
                    <img
                        className="selected-info-img"
                        alt={""}
                        src={toy_work_4}
                    />
                    <div
                        className="selected-info-msg"
                    >
                        내 길은 내가 만들지 / I create my own path <br />
                        - 2024.08
                        < a href="https://icreatemyownpath.netlify.app/" target="_blank" rel="noopener noreferrer">
                            <img
                                className="visit"
                                src={visit}
                                alt="visit"
                            />
                        </a>
                    </div>
                </div>
            );
        } else if (index === 78) {
            setSelectedInfo(
                <div
                    className="selected-info"
                >
                    <img
                        className="selected-info-img"
                        alt={""}
                        src={toy_work_5}
                    />
                    <div
                        className="selected-info-msg"
                    >
                        another hundred 2 <br />
                        - 2024.10
                        < a href="https://anotherhundred-2.netlify.app/" target="_blank" rel="noopener noreferrer">
                            <img
                                className="visit"
                                src={visit}
                                alt="visit"
                            />
                        </a>
                    </div>
                </div>
            );
        } else if (index === 99) {
            setSelectedInfo(
                <div
                    className="selected-info"
                >
                    <img
                        className="selected-info-img"
                        alt={""}
                        src={main_work_3}
                    />
                    <div
                        className="selected-info-msg"
                    >
                        1st media art project - media fasade <br />
                        - 2025.04
                        < a href="https://ellens1stmediaartwork.netlify.app/" target="_blank" rel="noopener noreferrer">
                            <img
                                className="visit"
                                src={visit}
                                alt="visit"
                            />
                        </a>
                    </div>
                </div>
            );
        } else {
            setSelectedInfo(
                <div
                    className="select-one"
                >
                    pick a box with an image
                </div>
            ); // 다른 셀을 클릭하면 내용 초기화
        }
    };

    // 그리드 칸을 생성 (120개의 그리드)
    const gridItems = Array.from({ length: 143 }, (_, index) => {
        const isBlue = blueCells.includes(index);

        if (index === 12) {
            return (
                <div
                    key={index}
                    className={`grid-item main ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <img
                        src={main_work_1}
                        alt="main_work_1"
                    />
                    <img
                        src={red_dot}
                        alt="main_projects"
                        className="red-dot"
                    />
                    {selectedCell === index && (
                        <img
                            src={selected} /* 가운데 추가 이미지 */
                            alt="selected-icon"
                            className="image-selected"
                        />
                    )}
                    <div className="overlay"></div> {/* 오버레이 추가 */}
                </div>
            );
        } else if (index === 14) {
            return (
                <div
                    key={index}
                    className={`grid-item main ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <img
                        src={main_work_2}
                        alt="main_work_2"
                    />
                    <img
                        src={red_dot}
                        alt="main_projects"
                        className="red-dot"
                    />
                    {selectedCell === index && (
                        <img
                            src={selected} /* 가운데 추가 이미지 */
                            alt="selected-icon"
                            className="image-selected"
                        />
                    )}
                    <div className="overlay"></div>
                </div>
            );
        } else if (index === 43) {
            return (
                <div
                    key={index}
                    className={`grid-item toy ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <img
                        src={toy_work_1}
                        alt="toy_work_1"
                    />
                    <img
                        src={yellow_dot}
                        alt="toy_projects"
                        className="yellow-dot"
                    />
                    {selectedCell === index && (
                        <img
                            src={selected} /* 가운데 추가 이미지 */
                            alt="selected-icon"
                            className="image-selected"
                        />
                    )}
                    <div className="overlay"></div>
                </div>
            );
        } else if (index === 45) {
            return (
                <div
                    key={index}
                    className={`grid-item toy ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <img
                        src={toy_work_2}
                        alt="toy_work_2"
                    />
                    <img
                        src={yellow_dot}
                        alt="toy_projects"
                        className="yellow-dot"
                    />
                    {selectedCell === index && (
                        <img
                            src={selected} /* 가운데 추가 이미지 */
                            alt="selected-icon"
                            className="image-selected"
                        />
                    )}
                    <div className="overlay"></div>
                </div>
            );
        } else if (index === 74) {
            return (
                <div
                    key={index}
                    className={`grid-item toy ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <img
                        src={toy_work_3}
                        alt="toy_work_3"
                    />
                    <img
                        src={yellow_dot}
                        alt="toy_projects"
                        className="yellow-dot"
                    />
                    {selectedCell === index && (
                        <img
                            src={selected} /* 가운데 추가 이미지 */
                            alt="selected-icon"
                            className="image-selected"
                        />
                    )}
                    <div className="overlay"></div>
                </div>
            );
        } else if (index === 76) {
            return (
                <div
                    key={index}
                    className={`grid-item toy ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <img
                        src={toy_work_4}
                        alt="toy_work_4"
                    />
                    <img
                        src={yellow_dot}
                        alt="toy_projects"
                        className="yellow-dot"
                    />
                    {selectedCell === index && (
                        <img
                            src={selected} /* 가운데 추가 이미지 */
                            alt="selected-icon"
                            className="image-selected"
                        />
                    )}
                    <div className="overlay"></div>
                </div>
            );
        } else if (index === 78) {
            return (
                <div
                    key={index}
                    className={`grid-item toy ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <img
                        src={toy_work_5}
                        alt="toy_work_5"
                    />
                    <img
                        src={yellow_dot}
                        alt="toy_projects"
                        className="yellow-dot"
                    />
                    {selectedCell === index && (
                        <img
                            src={selected} /* 가운데 추가 이미지 */
                            alt="selected-icon"
                            className="image-selected"
                        />
                    )}
                    <div className="overlay"></div>
                </div>
            );
        } else if (index === 99) {
            return (
                <div
                    key={index}
                    className={`grid-item main ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    <img
                        src={main_work_3}
                        alt="main_work_3"
                    />
                    <img
                        src={red_dot}
                        alt="main_projects"
                        className="red-dot"
                    />
                    {selectedCell === index && (
                        <img
                            src={selected} /* 가운데 추가 이미지 */
                            alt="selected-icon"
                            className="image-selected"
                        />
                    )}
                    <div className="overlay"></div>
                </div>
            );
        }

        if (isBlue) {
            return (
                <div
                    key={index}
                    className={`grid-item blue ${selectedCell === index ? 'selected' : ''}`}
                    onClick={() => handleClick(index)}
                >
                    {/* 필요한 콘텐츠 추가 */}
                </div>
            );
        }

        // 나머지 그리드 셀들
        return (
            <div
                key={index}
                className={`grid-item ${selectedCell === index ? 'selected' : ''}`}
                onClick={() => handleClick(index)}
            >
                {/* {index} */}
            </div>
        );
    });

    return (
        <div
            className="coding-container"
        >
            <div className='web-development-section'>

                <div className="web_development">
                    <img
                        className="web_development_rotating"
                        src={web_development[currentImageIndex]}
                        alt={`web_development_${currentImageIndex + 1}`}
                    />
                </div>

                <div
                    className='web-development-contents'
                >
                    {selectedInfo && <p>{selectedInfo}</p>}
                </div>
            </div>
            <div className="grid-container">
                <div className="grid-items">
                    {gridItems}
                </div>
            </div>
        </div>
    );
}

export default Coding;